import cns from 'classnames'
import { useTotalDebt } from 'modules/pools/hooks/useTotalDebt'

import { Text } from 'shared/ui/common/Text'
import { RoundCTAButton } from 'shared/ui/controls/RoundCTAButton'

import { formatAsset } from 'modules/pools/utils/formatAsset'
import * as links from 'modules/router/links'
import s from './DrawerDebtBubble.module.scss'

type Props = {
  className?: string
}

export function DrawerDebtBubble({ className }: Props) {
  const { totalOwe, poolNumber } = useTotalDebt()

  if (!totalOwe) return null

  return (
    <RoundCTAButton
      size={260}
      borderOffset={16}
      href={links.dashboardLoans}
      fashion="error"
      className={cns(s.button, className)}
      isExternal={false}
    >
      <Text
        size={14}
        weight={500}
        color="secondary"
        isUppercased
        className={s.title}
      >
        You owe
      </Text>
      <Text size={14} weight={500} className={s.text}>
        You owe {formatAsset(totalOwe, 'USD')} USD
        <br />
        to the pool {poolNumber}. Repay your
        <br />
        debt here now and
        <br />
        improve your NFCS
        <br />
        score
      </Text>
    </RoundCTAButton>
  )
}
